<template>
  <div>
    <section class="calculation-result">
      <div v-if="!this.dataLoaded" class="loader-container">
        <div class="loader"></div>
      </div>

      <div v-else>
        <CalculationResultBanner :value="this.value" :params="this.params" @scrollToSlider="scrollToSlider" />
        <div ref="calculationResultInfoWrapper">
          <CalculationResultInfo :value="this.value" :params="this.params" v-if="this.dataLoaded" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CalculationResultBanner from './CalculationResultBanner.vue';
import CalculationResultInfo from './CalculationResultInfo.vue';
import { getScrollbarWidth } from '~scripts/core/helpers';
import scrollTo from '~scripts/core/scrollTo';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
  name: 'CalculationResult',
  components: {
    CalculationResultBanner,
    CalculationResultInfo,
  },
  data() {
    return {
      dataLoaded: false,
    };
  },
  computed: {
    params() {
      return {
        cal_per_day: this.searchParams.get('cal_per_day'),
        mail_per_day: this.searchParams.get('mail_per_day'),
        mail_tpl_per_day: this.searchParams.get('mail_tpl_per_day'),
        resume_per_day: this.searchParams.get('resume_per_day'),
      };
    },
    searchParams() {
      const urlObject = new URL(window.location.href);
      return urlObject.searchParams;
    },
  },
  methods: {
    initEventListeners() {
      window.addEventListener('beforeunload', () => {
        window.scrollTo(0, 0);
      });
    },
    createHiddenInput() {
      const paramsWithNumbers = {};

      for (const key in this.params) {
        if (Object.prototype.hasOwnProperty.call(this.params, key)) {
          paramsWithNumbers[key] = +this.params[key];
        }
      }
      const inputValue = {
        amount: +this.searchParams.get('amount'),
        salary: +this.searchParams.get('salary'),
        params: paramsWithNumbers,
      };

      const input = document.createElement(`input`);
      input.type = 'hidden';
      input.name = 'saving';
      input.value = JSON.stringify(inputValue);

      return input;
    },
    scrollToSlider() {
      const rect = this.$refs.calculationResultInfoWrapper.getBoundingClientRect();
      scrollTo(rect.top + window.pageYOffset - 160, { duration: 1000 });
    },
    lockScroll() {
      const scrollbarWidth = getScrollbarWidth();
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      document.body.classList.add('no-scroll');
    },
    loadData() {
      this.lockScroll();

      Promise.all([
        (this.loadingPromise = fetch('/calc', {
          method: 'post',
          body: JSON.stringify({
            amount: this.searchParams.get('amount'),
            salary: this.searchParams.get('salary'),
            params: this.params,
          }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }).then((r) => r.json())),
        wait(3000),
      ]).then(([{ saving }]) => {
        this.value = saving;
        this.dataLoaded = true;
        document.querySelector('.js-demo-request-form').prepend(this.createHiddenInput());
      });
      return this.loadingPromise;
    },
  },
  mounted() {
    this.loadData();
    this.initEventListeners();
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

@keyframes loaderAnimation {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.loader-container {
  opacity: 0;
  animation: fadeIn 0.6s 0.2s forwards;
}

.loader {
  @include mixins.size(5.2rem);

  position: fixed;
  top: 50%;
  left: 50%;
  animation: loaderAnimation 1s infinite linear;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #16bf54 94%, #0000) top/8px 8px no-repeat,
    conic-gradient(#0000 0%, #16bf54);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  transform: translate(-50%, -50%);
  will-change: transform;

  @include mixins.media(md) {
    @include mixins.size(7rem);

    background:
      radial-gradient(farthest-side, #16bf54 94%, #0000) top/10px 10px no-repeat,
      conic-gradient(#0000 0%, #16bf54);
    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 10px), #000 0);
  }
}
</style>
